

<!DOCTYPE html>

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.8/css/all.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
</head>









<div class="card" *ngIf="ShowCard===2">
  <div class="card-body">
<br>
    <div class="row">
      <p style="color: #6ab187;"><strong>EMPLOYEE SCREENING</strong></p>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/users.png"><a style="text-decoration: none;color:black" routerLink="/whitecollar"> <strong class="white">&nbsp; White-collar verification</strong></a></div>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/mechanic.png"><a style="text-decoration: none;color: black;"  routerLink="/bluecollar"><strong class="white"> Blue-collar verification</strong></a></div>
      <br><br>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/online-business.png"><a style="text-decoration: none;color: black;" routerLink="/gigworker"> &nbsp;<strong class="white"> Gig Worker verification</strong></a></div>
    </div>
    <br>
    
    <div class="row">
      
      <p style="color: #6ab187;"><strong>RISK & COMPLIANCE</strong></p>
      <div class="col-3"><img style="width: 30px;height: auto;" src="assets/risktopicon.png"><a style="text-decoration: none;color: black;" routerLink="/riskmanage"><strong class="white"> Risk Management</strong></a></div>
      <div class="col-3"><img style="width: 35px;height: auto;" src="assets/onboarding.png"><a style="text-decoration: none;color: black;" routerLink="/vendor"><strong class="white" > Vendor Onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/distributortopicon.png"><a style="text-decoration: none;color: black;" routerLink="/distribute"><strong class="white"> Distributor onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/duediligence.jpg"><a style="text-decoration: none;color: black;" routerLink="/duediligence"><strong class="white"> Due Diligence</strong> </a></div>
    </div>
    <br>
  
    <!--  -->
    <div class="row">
      
      <p style="color: #6ab187;"><strong> FINANCIAL INTELLIGENCE</strong></p>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/kycsolution.png"><a style="text-decoration: none;color: black;" routerLink="/kycsolution"><strong class="white"> KYC solutions</strong> </a></div>
    </div>
    <br>
  
  </div>
</div>


<div class="card" *ngIf="ShowCard===1">
  <div class="card-body">
<br>
<p style="color: #6ab187;font-weight: 600;"><strong>PRODUCT</strong></p>

    <div class="row">
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" (click)="ShowCard=3"><strong class="white"><img style="width: 4%;height: 100%;" src="assets/docverify.png"> Document Verification</strong> </a></div>
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" routerLink="/service"><strong class="white"><img style="width: 5%;height: 110%;" src="assets/docsignin.png"> Document SignIn</strong> </a></div>
  
    </div>
    <br>

    <div class="row">
       </div>
    <br>
    
  </div>
</div>


<!--  -->

<div class="card" *ngIf="ShowCard===3">
  <div class="card-body">
    <br>
<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/aadhartopicon.png"><a style="text-decoration: none;color: black;" routerLink="/aadhaar"> <strong class="white"> Aadhaar verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/pantopicon.png"><a style="text-decoration: none;color: black;"  routerLink="/pan"><strong class="white"> Pan verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/gsttopicon.jpg"><a style="text-decoration: none;color: black;" routerLink="/gst"><strong class="white"> Gst verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/drivinglicensetop.jpg"><a style="text-decoration: none;color: black;" routerLink="/driving"><strong class="white"> Driving verification</strong></a></div>
</div><br><br>

<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/passporttopicon.png"><a style="text-decoration: none;color: black;" routerLink="/passport"><strong class="white"> Passport verification</strong> </a></div>
  <div class="col"><img style="width: 58px;height: 44px;" src="assets/rcverify.png"><a style="text-decoration: none;color: black;" routerLink="/rcverify"><strong class="white"> RC verification</strong></a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/msmeverify.png"><a style="text-decoration: none;color: black;" routerLink="/msmeverify"><strong class="white"> MSME verification</strong> </a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/verification.png"><a style="text-decoration: none;color: black;" routerLink="/dinverify"><strong class="white"> DIN verification</strong></a></div>
</div>

<br><br>
<div class="row">
  <div class="col-3"><img style="width: 35px;height: 44px;border-radius: 20px;" src="assets/cinicon.png"><a style="text-decoration: none;color: black;" routerLink="/cinverify"><strong  class="white"> CIN verification</strong></a></div>
</div>
</div>
</div>


<br>


<div class="row p-2" data-aos="zoom-in" data-aos-delay="300"  >
  <div class="col-md-6">
    <img style="width:70%;height: 90%;margin-top:10%;border-radius:40px;box-shadow: 50px 20px #76b891;" src="assets/gigeco.png">
</div>
    <div  class="col-md-6 mt-5">
        <h1>
            <span class="topic">Third Party Onboarding and Risk Management</span>
          </h1>
        <h5 >&nbsp;&nbsp;&nbsp;A comprehensive platform designed to help business like yours mitigate risks, enhance security, and ensure compliance when engaging with external vendors, suppliers, and partners</h5>
    </div>

   
</div>
<br><br>
<br>


<br><br>
<div class="row" data-aos="zoom-in" data-aos-delay="300">
    <div class="col">
        <h1 style="color: #6ab187;text-align: center;">Overcoming the Challenges with <br>Third Party Onboarding and Verification</h1>
        <br>
        <p style="text-align: center;">Seamless third-party onboarding and risk management</p>


           <br><br>
<div  class="row">

    <div style="background-color: #eff8ff;"  class="col-md-3">
        <br>
        <img style="width: 70px;height: 65px;background-color: #eff8ff;" src="assets/activity.png">
       <br><br><br>
        <h5>Siloed View of Activities</h5>
        <p style="align-items: center;">Have complete visibility of activities and stages across third-party onboarding lifecycle</p>
    </div>
  
    <div style="background-color: #c9d9e6;" class="col-md-3">
          <br>
          <img style="width: 70px;height: 60px;" src="assets/theft.png">
         <br><br><br>
          <h5>Risk Assessment</h5>
          <p style="align-items: center;">Safeguard your business against financial, criminal, operational and other risks associated with third-parties</p>
      </div>
     
       
    <div style="background-color: #eff8ff;"  class="col-md-3">
        <br>
        <img style="width: 70px;height: 60px;" src="assets/theft.png">
       <br><br><br>
        <h5>Maintaining Compliance Standards </h5>
        <p style="align-items: center;">Ensure your third-parties comply with regulatory compliances and be alerted of any defaulters.</p>
    </div>

      <div style="background-color: #c9d9e6;" class="col-md-3">
     
        <br>
        <img style="width: 70px;height: 70px;" src="assets/streamline.png">
       <br><br><br>
        <h5>Inventorization of Third</h5>
        <p style="align-items: center;">Maintain a repository of all third-parties to save on time, effort and cost of repeating due diligence activities.<p>
    </div>
  </div>
    </div>
</div> 

<br><br><br>
<!--  -->

<div class="row" data-aos="zoom-in" data-aos-delay="300">
    <div  class="col">
        <h2 style="color: #6ab187;text-align: center;">Onboard Third-Parties Quickly</h2>

        <br><br>
  <div  class="row p-3">

    <div   class="col-md-3">
        <br>
        <img style="width: 60px;height: 65px;" src="assets/multiplechannel.jpg">
       <br><br><br>
        <h5>STEP 1</h5>
        <p style="align-items: center;">Initiate the registration process via multiple channels</p>
    </div>
  
    <div class="col-md-3">
          <br>
          <img style="width: 80px;height: 80px;" src="assets/due.jpg">
         <br><br>
          <h5>STEP 2</h5>
          <p style="align-items: center;">Automated data collection and due diligence</p>
      </div>
     
      <div class="col-md-3">
     
        <br>
        <img style="width: 70px;height: 60px;" src="assets/thirdparty.png">
       <br><br><br>
        <h5 >STEP 3</h5>
        <p style="align-items: center;">Approvals for third-party onboarding<p>
    </div>

    <div class="col-md-3">
     
        <br>
        <img style="width: 60px;height: 60px;" src="assets/postonboard.png">
       <br><br><br>
        <h5 >STEP 4</h5>
        <p style="align-items: center;">ERP integrations and post-onboarding <br>risk watch<p>
    </div>
  
  </div>
    </div>
</div>
 



<div class="row" data-aos="zoom-in" data-aos-delay="300">
    <div class="col">
        <h3 style="color: #6ab187;text-align: center;">Third Party Due Diligence and Risk<br> Management Solution</h3>
        <p style="text-align: center;">Collaborate with authentic third-parties with fast, easy and efficient onboarding solution</p><br>
     
    </div>
</div>

<br><br>
<!--  -->
<div class="row p-2" data-aos="fade-up" data-aos-delay="300">
  <div class="col-md-6">
      <br>
      <img style="width: 39px;height: 39px" src="assets/page.png">
      <span style="color: #6ab187;">TPRM</span><br>
      <h3 style="text-align: start;color: #6ab187;">End to End Risk Assessment</h3>
      <p> Get a holistic approach to risk assessment – enabling you to identify, analyze, and prioritize potential risks associated with third-party relationships. By conducting thorough evaluations, you can make well-informed decisions, ensuring that your business is protected from vulnerabilities.</p>
  </div>

  <div class="col-md-6 text-center">
      <img style="width: 80%;height: 80%;margin-top: 20px;" src="assets/risktprm.png">
  </div>
  </div>


   <!--  -->
   
   <div class="row p-2" data-aos="fade-up" data-aos-delay="300">
    
       <div class="col-md-6 text-center">
           <img style="width: 80%;height: 100%;margin-left: 20px;" src="assets/onboardexperience.png">
       </div>
   
       <div class="col-md-6">
           <img style="width: 42px;height: 45px;" src="assets/duediligent.png">
           <span style="color: #6ab187;height: 20%;">Due Diligence</span>
           <h3 style="text-align: start;color: #6ab187;">Streamlined Onboarding Experience </h3>
           <p >Iron out the entire onboarding process for your partners, vendors, suppliers, distributors, etc while ensuring that each third-party undergoes rigorous due diligence.  Confidently engage with reliable and trustworthy partners.</p>
       </div>
   </div>



  
   <!--  -->
   <div class="row p-2" data-aos="fade-up" data-aos-delay="300">
     <div class="col-md-6">
         <br>
         <img style="width: 39px;height: 39px;" src="assets/page.png">
         <span style="color: #6ab187;">Risk Watch</span><br>
         <h3 style="text-align: start;color: #6ab187;">Continuous Monitoring</h3>
         <p >Risk does not end with third -party onboarding. Be proactive with risk watch. Receive real-time alerts if any potential risks arise, allowing you to take swift  action and prevent potential threats.</p>
     </div>
   
     <div class="col-md-6 text-center ">
         <img style="width: 80%;height: 80%;margin-top: 20px;" src="assets/continuousmonitor.jpeg">
     </div>
     </div>


    
     <div class="row p-2" data-aos="fade-up" data-aos-delay="300">
      
         <div class="col-md-6 text-center  ">
             <img style="width: 80%;height: 90%;margin-left: 20px;" src="assets/report&dashboard.png">
         </div>
     
         <div class="col-md-6">
             <img style="width: 42px;height: 45px;" src="assets/reporticon.jpg">
             <span style="color: #6ab187;height: 20%;margin-top: 30px;">Reports & Dashboards </span>
             <h3 style="text-align: start;color: #6ab187;">Centralized Dashboard </h3>
             <p >Access all your third-party risk information in one centralized and user-friendly dashboard. No more scattered documents or spreadsheets – our solution offers a seamless and consolidated view of your risk landscape.</p>
         </div>
     </div>
  


   
     <!--  -->
     <div class="row p-2"  data-aos="fade-up" data-aos-delay="300">
       <div class="col-md-6">
           <br>
           <img style="width: 39px;height: 42px;" src="assets/configuration.png">
           <span style="color: #6ab187;">Configurable</span><br>
           <h3 style="text-align: start;color: #6ab187;">Customizable to Your Needs</h3>
           <p >Our Third-Party Risk Management Solution is highly customizable to fit your specific requirements and industry standards, ensuring you get the most out of the platform.</p>
       </div>
     
       <div class="col-md-6 text-center ">
           <img style="width: 80%;height: 90%;margin-top: 20px;" src="assets/config.png">
       </div>
       </div>
  



       <br><br>
       <div class="row p-2"  data-aos="fade-up" data-aos-delay="300">
        
           <div class="col-md-6 text-center">
               <img style="width: 80%;height: 90%;margin-left:20px;" src="assets/expertsupport.jpg">
           </div>
       
           <div class="col-md-6">
               <img style="width: 42px;height: 50px;" src="assets/mailicon.png">
               <span style="color: #6ab187;height: 20%;">Due Diligence</span>
               <h3 style="text-align: start;color: #6ab187;">Expert Support</h3>
               <p >Our Team of experienced professionals is always ready to assist you. Whether it’s implementation support, training, or addressing any queries, we provide comprehensive and dedicated customer support to ensure your success with our solution.</p>
           </div>
       </div>


<!--  -->
       <div class="row" data-aos="zoom-in" data-aos-delay="300"  >
        <div class="col">
          <br><br><br>
            <h3 style="text-align: center;color: #6ab187;">Due Diligence Checks for Third Party<br> Risk Management</h3><br>
            <p style="text-align: center;">Vet your third-parties with extensive checks</p>
        </div>
    
    </div>
  
    

<!--  -->
    <div  class="row p-2 text-center"  data-aos="fade-up" data-aos-delay="300"  >
      <div class="col-md-3 mt-2">
          <div  class="card" style="height: 200px;" >
              <div class="card-body">
                  <img style="width: 34%;height:30%" src="assets/udyogaadhaar.jpg">
                  <br><br>
                <h5 class="card-title">Udyog Aadhaar</h5>
              </div>            
            </div>
      </div>
  
      <div class="col-md-3 mt-2">
        <div class="card" style="height: 200px;" >
            <div class="card-body">
                <img style="width: 34%;height:30%" src="assets/bankaccount.png">
                <br><br>
              <h5 class="card-title">Bank Account</h5>
            </div>            
          </div>
    </div>
  
    <div class="col-md-3 mt-2">
      <div class="card" style="height: 200px;" >
          <div  class="card-body">
  
              <img style="width: 30%;height:30%" src="assets/directorcheck.jpg">
              <br><br>
            <h5 class="card-title">Defaulting Directors Check</h5>
          </div>            
        </div>
  </div>
  
  <div class="col-md-3 mt-2">
    <div class="card" style="height: 200px;" >
        <div class="card-body">
            <img style="width: 34%;height:30%"  src="assets/tincheck.png">
            <br><br>
          <h5 class="card-title">TIN Check</h5>
  
        </div>            
      </div>
  </div>
  <div class="col-md-3 mt-2">
    <div  class="card" style="height: 200px;" >
        <div class="card-body">
            <img style="width: 34%;height:30%" src="assets/businesswork.png">
            <br><br>
          <h5 class="card-title">Business address</h5>
        </div>            
      </div>
</div>

<div class="col-md-3 mt-2">
  <div class="card" style="height: 200px;" >
      <div class="card-body">
          <img style="width: 34%;height:30%" src="assets/GSTIN.jpg">
          <br><br>
        <h5 class="card-title">GSTIN verify</h5>
      </div>            
    </div>
</div>

<div class="col-md-3 mt-2">
<div class="card" style="height: 200px;" >
    <div  class="card-body">

        <img style="width: 30%;height:30%" src="assets/panchecks.png">
        <br><br>
      <h5 class="card-title">PAN Card</h5>
    </div>            
  </div>
</div>

<div class="col-md-3 mt-2">
<div class="card" style="height: 200px;" >
  <div class="card-body">
      <img style="width: 34%;height:30%"  src="assets/dinverify.jpg">
      <br><br>
    <h5 class="card-title">DIN verify</h5>
  </div>            
</div>
</div>
    </div>
  
  

<!--  -->

  



 







